import { Box, Button, Typography, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { selectCurrCustomerID } from '../../select/selectSlice';
import { setRanchSummaryTableDateRange } from '../dataGridTablesSlice';
import useCreateRanchSummaryTableDateRange from './hooks/useCreateRanchSummaryTableDateRange';
const NoRowsOverlayRanchSummary: React.FC = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const currCustomerID = useAppSelector(selectCurrCustomerID);
  const { daysSinceNow } = useCreateRanchSummaryTableDateRange();

  const noDataText = useMemo(() => {
    if (!currCustomerID) {
      return t('Select a customer to view scan history');
    }

    const noDataText =
      daysSinceNow === undefined
        ? t('No scans found')
        : t('No scans done in the last {{numDays}} days', {
            numDays: daysSinceNow,
          });

    return noDataText;
  }, [currCustomerID, t, daysSinceNow]);

  const handleSeeAllScansClick = () => {
    dispatch(setRanchSummaryTableDateRange('all'));
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1rem',
      }}
    >
      <Typography
        sx={{
          color: theme.colors.canopy.content.primary,
          fontSize: '1rem',
          fontWeight: 500,
        }}
      >
        {noDataText}
      </Typography>
      {currCustomerID && daysSinceNow !== undefined && (
        <Button
          onClick={handleSeeAllScansClick}
          sx={{
            border: `1px solid ${theme.colors.canopy.grey[200]}`,
            borderRadius: '0.5rem',
            fontSize: '0.875rem',
            color: theme.colors.canopy.content.primary,
            p: '0.625rem 1rem',
            bgcolor: theme.colors.canopy.invert,
            '&:hover': {
              bgcolor: theme.colors.canopy.grey[200],
            },
          }}
        >
          {t('See All Scans')}
        </Button>
      )}
    </Box>
  );
};

export default NoRowsOverlayRanchSummary;
